import { useHistory } from "react-router-dom";
import CheckMarkSVG from "../assets/svg/CheckMarkSVG";
import Button from "../components/organism/Button";
import LandingPageLayout from "../layouts/LandingPageLayout";

function VerifyEmail() {
  const history = useHistory();

  function handleMain() {
    history.replace("/");
  }

  return (
    <LandingPageLayout>
      <div className="flex flex-col h-full justify-center items-center">
        <CheckMarkSVG />
        <div className="w-4/6 md:w-2/6 text-center p-5">
          <p className="text-royalBlue font-medium">
            Thank you for submitting your request. An email will be shared with
            you to confirm that we have received your request. You will be
            notified when your account is ready in the next 24 to 48 hours.
          </p>
          <div className="flex justify-center w-full items-center my-5">
            <Button
              buttonTheme="secondary"
              textInformation={{
                text: "Back to Main Screen",
                fontWeight: "font-semibold",
              }}
              onClick={handleMain}
            />
          </div>
        </div>
      </div>
    </LandingPageLayout>
  );
}
export default VerifyEmail;
